import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

const LotCategoriesTourConfig: AgTechTourConfig = {
    id: 'sale-settings-lot-categories-page-tour',
    name: 'Lot Categories Tour',
    steps: [
        {
            targetId: 'settings-lot-categories-page',
            title: 'Lot Categories',
            description: 'Categories group your lots, for example by breed or class, and are color coded. Click a category name to edit it, search by name or description, or use the row menu for more actions.',
            position: 'left',
        },
        {
            targetId: 'settings-lot-category-create',
            skipIfMissing: true,
            title: 'Create a Category',
            description: 'Add a new lot category. Once created it can be assigned to lots when you create or edit them.',
            position: 'bottom',
        },
    ]
}

const ChargesDiscountsTourConfig: AgTechTourConfig = {
    id: 'sale-settings-charges-discounts-page-tour',
    name: 'Charges and Discounts Tour',
    steps: [
        {
            targetId: 'settings-modifiers-page',
            title: 'Charges and Discounts',
            description: 'Fees such as a buyer premium and deductions such as a discount that you can apply to invoices. Each has an amount, which is either a fixed dollar value or a percentage, and a category of Charge or Discount. Click a name to edit it.',
            position: 'left',
        },
        {
            targetId: 'settings-modifier-create',
            skipIfMissing: true,
            title: 'Create a Charge or Discount',
            description: 'Add a new modifier. Once created it can be selected when you create or update an invoice.',
            position: 'bottom',
        },
    ]
}

const TaskTemplatesTourConfig: AgTechTourConfig = {
    id: 'sale-settings-task-templates-page-tour',
    name: 'Task Templates Tour',
    steps: [
        {
            targetId: 'settings-task-templates-page',
            title: 'Task Templates',
            description: 'Reusable checklists of planning tasks. Click a template name to edit its items, or use the row menu for more actions. Apply a template from the Planning Tasks tab of any sale.',
            position: 'left',
        },
        {
            targetId: 'settings-task-template-create',
            skipIfMissing: true,
            title: 'Create a Template',
            description: 'Build a new template. Each item is scheduled relative to the sale start date, so one template works for every sale.',
            position: 'bottom',
        },
    ]
}

const DocumentHeadersTourConfig: AgTechTourConfig = {
    id: 'sale-settings-document-headers-page-tour',
    name: 'Document Headers Tour',
    steps: [
        {
            targetId: 'settings-doc-header-address',
            title: 'Address Override',
            description: 'Set the street address printed in the header of your documents when it should differ from your operation address.',
            position: 'bottom',
        },
        {
            targetId: 'settings-doc-header-city',
            title: 'City, State and Zip',
            description: 'The rest of the address override.',
            position: 'bottom',
        },
        {
            targetId: 'settings-doc-header-post',
            title: 'Post-Address Line',
            description: 'An optional extra line printed after the address, such as a phone number or website.',
            position: 'bottom',
        },
        {
            targetId: 'settings-doc-header-pre',
            title: 'Pre-Address Line',
            description: 'An optional extra line printed before the address.',
            position: 'bottom',
        },
        {
            targetId: 'settings-doc-header-save',
            title: 'Save Changes',
            description: 'Save is enabled once you change something.',
            position: 'left',
        },
    ]
}

const InvoiceFieldsTourConfig: AgTechTourConfig = {
    id: 'sale-settings-invoice-fields-page-tour',
    name: 'Invoice Fields Tour',
    steps: [
        {
            targetId: 'settings-invoice-labels',
            title: 'Column and Label Text',
            description: 'Customize the wording used for the item number, purchase price and checks payable text on your invoices.',
            position: 'bottom',
        },
        {
            targetId: 'settings-invoice-description',
            title: 'Description Text',
            description: 'The heading used for the lot description column.',
            position: 'bottom',
        },
        {
            targetId: 'settings-invoice-thanks',
            title: 'Thank You Text',
            description: 'A closing message printed on every invoice.',
            position: 'bottom',
        },
        {
            targetId: 'settings-invoice-sample',
            title: 'Download a Sample',
            description: 'Download a sample invoice to preview how your wording looks.',
            position: 'left',
        },
        {
            targetId: 'settings-invoice-save',
            title: 'Save Changes',
            description: 'Save is enabled once you change something.',
            position: 'left',
        },
    ]
}

const LogoTourConfig: AgTechTourConfig = {
    id: 'sale-settings-logo-page-tour',
    name: 'Logo Tour',
    steps: [
        {
            targetId: 'settings-logo-area',
            title: 'Operation Logo',
            description: 'Your logo is shown on documents such as invoices.',
            position: 'left',
        },
        {
            targetId: 'settings-logo-upload',
            title: 'Upload a Logo',
            description: 'Choose an image file to upload. A new upload replaces the current logo.',
            position: 'top',
        },
    ]
}

const TeamTourConfig: AgTechTourConfig = {
    id: 'sale-settings-team-page-tour',
    name: 'Team Tour',
    steps: [
        {
            targetId: 'settings-team-page',
            title: 'Your Team',
            description: 'Everyone in your operation with their roles. Search by user name or name, and use the row menu to manage a team member roles.',
            position: 'left',
        },
    ]
}

export const getSaleSettingsTabTourConfigs = (): Record<string, AgTechTourConfig> => ({
    'sale-settings-lot-categories-tab': LotCategoriesTourConfig,
    'sale-settings-charges-discounts-tab': ChargesDiscountsTourConfig,
    'sale-settings-task-templates-tab': TaskTemplatesTourConfig,
    'sale-settings-document-headers-tab': DocumentHeadersTourConfig,
    'sale-settings-invoice-fields-tab': InvoiceFieldsTourConfig,
    'sale-settings-logo-tab': LogoTourConfig,
    'sale-settings-team-tab': TeamTourConfig,
})
